import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FeatureToasterModule } from '@auto-editor/feature-toaster';
import { HttpConfigInterceptor, HttpErrorInterceptor, RefreshInterceptor } from '@auto-editor/interceptors';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from '@auto-editor/shared/models';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FeatureToasterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactoryGeneral,
        deps: [HttpClient]
      }
    })
  ],
  exports: [],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: false })
  ]
})
export class AppModule {}

export function HttpLoaderFactoryGeneral(http: HttpClient): MultiTranslateHttpLoader {
  //return new TranslateHttpLoader(http, 'assets/general/', '.general.json')
  return new MultiTranslateHttpLoader(http, [
    {
      prefix: './assets/elements/',
      suffix: `.elements.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/core-layout/',
      suffix: `.core-layout.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/components/',
      suffix: `.components.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/general/',
      suffix: `.general.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/view-dashboard/',
      suffix: `.view-dashboard.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/modals/',
      suffix: `.modals.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/share/',
      suffix: `.share.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/feature-auth/',
      suffix: `.feature-auth.json?cacheBuster=${new Date().getTime()}`
    },
    {
      prefix: './assets/view-editor/',
      suffix: `.view-editor.json?cacheBuster=${new Date().getTime()}`
    }
  ]);
}
